import { urlRegex } from '@/constants/regex';

const phoneReplaceRegex = /(?!^\+)[^\d\r\n]+/g;

/** ASCII, curly (iOS/macOS), Ukrainian typographic, and lookalike apostrophes. */
const APOSTROPHE_VARIANTS_REGEX = /['\u2019\u02BC\u2018\u2032\u02B9\u00B4\u0060\uFF07\u201B]/g;

export const normalizeApostrophes = (value = '') => value.replace(APOSTROPHE_VARIANTS_REGEX, "'");

export const normalizePhone = (phone = '') => {
  const cleared = phone.replace(phoneReplaceRegex, '');

  if (cleared && !cleared.startsWith('+')) {
    return `+${cleared}`;
  }
  return cleared;
};

export const normalizeNumber = (value = '') => value.replace(/\D/g, '');

export const getOrigin = (link: string) => {
  const cleared = (link || '').replace(/http:\/\/|https:\/\//, '');
  return cleared.split('/')[0];
};

export const normalizeExternalLink = (link: string) => {
  if (urlRegex.test(link || '')) {
    return link;
  }

  return `https://${(link || '').replace(/^\//, '')}`;
};
